import {Box, Flex, ListItem, OrderedList} from "@chakra-ui/react";
import {useTranslation} from "react-i18next";
import BackgroundComponent from "../components/backgorund/BackgroundComponent";
import React from "react";

const TermsOfUsePage = () => {
    const [t, i18n] = useTranslation('common');
    return <Box paddingRight="20px"
                paddingLeft="20px"
                paddingTop="10px"
                className="App-body">
        <Flex direction="column" className="terms-page">
        <span className="body-content-small-gray">
              {t("Updated")} 08.10.2021
        </span>
            <Box marginBottom="40px" marginTop="10px" textAlign="left">
                <span className="body-description">{t("Indie Terms of Use")}</span>
            </Box>
            <Box className="body-content-small-gray">
                <span>{t("Terms of use header")}</span>
                <OrderedList>
                    <ListItem className="sub-header-privacy" padding={2}> <span>{t("Indie Rules")}</span>
                        <OrderedList className="body-privacy" listStyleType="lower-alpha">
                            <ListItem padding={2}>
                                {t("Indie Rules 1")}
                                <OrderedList listStyleType="lower-roman">

                                    {Array(2).fill(null).map((value, index) => (
                                        <ListItem padding={2}>
                                            <span>{t("Indie Rules 1 " + (index + 1))}</span>
                                        </ListItem>
                                    ))}

                                </OrderedList>
                            </ListItem>

                            {Array(5).fill(null).map((value, index) => (
                                <ListItem padding={2}>
                                    <span>{t("Indie Rules " + (index + 2))}</span>
                                </ListItem>
                            ))}
                        </OrderedList>
                    </ListItem>
                    <ListItem className="sub-header-privacy" padding={2}> <span>{t("Types of Content")}</span>
                        <OrderedList className="body-privacy" listStyleType="lower-alpha">
                            <ListItem padding={2}>
                                {t("Types of Content 1")}
                                <OrderedList listStyleType="lower-roman">

                                    {Array(3).fill(null).map((value, index) => (
                                        <ListItem padding={2}>
                                            <span>{t("Types of Content 1 " + (index + 1))}</span>
                                        </ListItem>
                                    ))}

                                </OrderedList>
                            </ListItem>
                            <ListItem padding={2}>
                                {t("Types of Content 2")}
                                <OrderedList listStyleType="lower-roman">

                                    {Array(12).fill(null).map((value, index) => (
                                        <ListItem padding={2}>
                                            <span>{t("Types of Content 2 " + (index + 1))}</span>
                                        </ListItem>
                                    ))}

                                </OrderedList>
                            </ListItem>
                            <ListItem padding={2}>
                                {t("Types of Content 3")}
                            </ListItem>
                            <ListItem padding={2}>
                                {t("Types of Content 4")}
                                <OrderedList listStyleType="lower-roman">

                                    {Array(5).fill(null).map((value, index) => (
                                        <ListItem padding={2}>
                                            <span>{t("Types of Content 4 " + (index + 1))}</span>
                                        </ListItem>
                                    ))}

                                </OrderedList>
                            </ListItem>
                            <ListItem padding={2}>
                                {t("Types of Content 5")}
                                <OrderedList listStyleType="lower-roman">

                                    {Array(3).fill(null).map((value, index) => (
                                        <ListItem padding={2}>
                                            <span>{t("Types of Content 5 " + (index + 1))}</span>
                                        </ListItem>
                                    ))}

                                </OrderedList>
                            </ListItem>
                            <ListItem padding={2}>
                                {t("Types of Content 6")}
                                <OrderedList listStyleType="lower-roman">
                                    <ListItem padding={2}>
                                        <span>{t("Types of Content 6 1")}</span>
                                    </ListItem>
                                    <ListItem padding={2}>
                                        <span>{t("Types of Content 6 2")}</span>
                                        <OrderedList>

                                            {Array(4).fill(null).map((value, index) => (
                                                <ListItem padding={2}>
                                                    <span>{t("Types of Content 6 2 " + (index + 1))}</span>
                                                </ListItem>
                                            ))}

                                        </OrderedList>
                                    </ListItem>
                                    {Array(3).fill(null).map((value, index) => (
                                        <ListItem padding={2}>
                                            <span>{t("Types of Content 6 " + (index + 3))}</span>
                                        </ListItem>
                                    ))}


                                </OrderedList>
                            </ListItem>

                        </OrderedList>
                    </ListItem>
                    <ListItem className="sub-header-privacy" padding={2}> <span>{t("Restrictions on the app")}</span>
                        <OrderedList className="body-privacy" listStyleType="lower-alpha">
                            <ListItem padding={2}>
                                {t("Restrictions on the app 1")}
                                <OrderedList listStyleType="lower-roman">

                                    {Array(3).fill(null).map((value, index) => (
                                        <ListItem padding={2}>
                                            <span>{t("Restrictions on the app 1 " + (index + 1))}</span>
                                        </ListItem>
                                    ))}

                                </OrderedList>
                            </ListItem>
                            <ListItem padding={2}>
                                {t("Restrictions on the app 2")}
                                <OrderedList listStyleType="lower-roman">

                                    {Array(5).fill(null).map((value, index) => (
                                        <ListItem padding={2}>
                                            <span>{t("Restrictions on the app 2 " + (index + 1))}</span>
                                        </ListItem>
                                    ))}

                                </OrderedList>
                            </ListItem>
                            {Array(5).fill(null).map((value, index) => (
                                <ListItem padding={2}>
                                    <span>{t("Restrictions on the app " + (index + 3))}</span>
                                </ListItem>
                            ))}
                        </OrderedList>
                    </ListItem>
                    <ListItem className="sub-header-privacy" padding={2}> <span>{t("Privacy")}</span>
                        <OrderedList className="body-privacy" listStyleType="lower-alpha">

                            <ListItem padding={2}>
                                <span>{t("Privacy 1")}</span>
                            </ListItem>
                        </OrderedList>
                    </ListItem>
                    <ListItem className="sub-header-privacy" padding={2}> <span>{t("Payment Terms")}</span>
                        <OrderedList className="body-privacy" listStyleType="lower-alpha">

                            {Array(6).fill(null).map((value, index) => (
                                <ListItem padding={2}>
                                    <span>{t("Payment Terms " + (index + 1))}</span>
                                </ListItem>
                            ))}
                            {Array(3).fill(null).map((value, mindex) => (
                                <ListItem padding={2}>
                                    <span>{t("Payment Terms " + (mindex + 7))}</span>
                                    <OrderedList listStyleType="lower-roman">

                                        <ListItem padding={2}>
                                            <span>{t("Payment Terms " + (mindex + 7) + " 1")}</span>
                                        </ListItem>


                                    </OrderedList>
                                </ListItem>
                            ))}
                        </OrderedList>
                    </ListItem>
                    <ListItem className="sub-header-privacy" padding={2}> <span>{t("Virtual Items")}</span>
                        <OrderedList className="body-privacy" listStyleType="lower-alpha">

                            {Array(4).fill(null).map((value, index) => (
                                <ListItem padding={2}>
                                    <span>{t("Virtual Items " + (index + 1))}</span>
                                </ListItem>
                            ))}
                        </OrderedList>
                    </ListItem>
                    <ListItem className="sub-header-privacy" padding={2}>
                        <span>{t("Push Notifications; Location-Based Features")}</span>
                        <OrderedList className="body-privacy" listStyleType="lower-alpha">

                            {Array(2).fill(null).map((value, index) => (
                                <ListItem padding={2}>
                                    <span>{t("Push Notifications; Location-Based Features " + (index + 1))}</span>
                                </ListItem>
                            ))}
                        </OrderedList>
                    </ListItem>
                    <ListItem className="sub-header-privacy" padding={2}>
                        <span>{t("DISCLAIMER")}</span>
                        <OrderedList className="body-privacy" listStyleType="lower-alpha">

                            {Array(3).fill(null).map((value, index) => (
                                <ListItem padding={2}>
                                    <span>{t("DISCLAIMER " + (index + 1))}</span>
                                </ListItem>
                            ))}
                        </OrderedList>
                    </ListItem>
                    <ListItem className="sub-header-privacy" padding={2}>
                        <span>{t("LIMITATION OF LIABILITY")}</span>
                        <OrderedList className="body-privacy" listStyleType="lower-alpha">

                            {Array(4).fill(null).map((value, index) => (
                                <ListItem padding={2}>
                                    <span>{t("LIMITATION OF LIABILITY " + (index + 1))}</span>
                                </ListItem>
                            ))}
                        </OrderedList>
                    </ListItem>
                    <ListItem className="sub-header-privacy" padding={2}>
                        <span>{t("Indemnity")}</span>
                        <OrderedList className="body-privacy" listStyleType="lower-alpha">
                            <ListItem padding={2}>
                                {t("Indemnity 1")}
                                <OrderedList listStyleType="lower-roman">

                                    {Array(5).fill(null).map((value, index) => (
                                        <ListItem padding={2}>
                                            <span>{t("Indemnity 1 " + (index + 1))}</span>
                                        </ListItem>
                                    ))}

                                </OrderedList>
                            </ListItem>

                            {Array(2).fill(null).map((value, index) => (
                                <ListItem padding={2}>
                                    <span>{t("Indemnity " + (index + 2))}</span>
                                </ListItem>
                            ))}
                        </OrderedList>

                    </ListItem>
                    <ListItem className="sub-header-privacy" padding={2}>
                        <span>{t("Digital Millennium Copyright Act")}</span>
                        <OrderedList className="body-privacy" listStyleType="lower-alpha">
                            <ListItem padding={2}>
                                {t("Digital Millennium Copyright Act 1")}
                                <OrderedList listStyleType="lower-roman">

                                    {Array(6).fill(null).map((value, index) => (
                                        <ListItem padding={2}>
                                            <span>{t("Digital Millennium Copyright Act 1 " + (index + 1))}</span>
                                        </ListItem>
                                    ))}

                                </OrderedList>
                            </ListItem>

                        </OrderedList>

                    </ListItem>
                    <ListItem className="sub-header-privacy" padding={2}>
                        <span>{t("Third Party App Store")}</span>
                        <OrderedList className="body-privacy" listStyleType="lower-alpha">

                            {Array(6).fill(null).map((value, index) => (
                                <ListItem padding={2}>
                                    <span>{t("Third Party App Store " + (index + 1))}</span>
                                </ListItem>
                            ))}


                        </OrderedList>

                    </ListItem>
                    <ListItem className="sub-header-privacy" padding={2}>
                        <span>{t("Dispute Resolution")}</span>
                        <OrderedList className="body-privacy" listStyleType="lower-alpha">
                            <ListItem padding={2}>
                                {t("Dispute Resolution 1")}
                                <OrderedList listStyleType="lower-roman">

                                    {Array(9).fill(null).map((value, index) => (
                                        <ListItem padding={2}>
                                            <span>{t("Dispute Resolution 1 " + (index + 1))}</span>
                                        </ListItem>
                                    ))}

                                </OrderedList>
                            </ListItem>

                        </OrderedList>

                    </ListItem>
                    <ListItem className="sub-header-privacy" padding={2}>
                        <span>{t("Use of Third Party Integrations")}</span>
                        <OrderedList className="body-privacy" listStyleType="lower-alpha">
                            <ListItem padding={2}>
                                {t("Use of Third Party Integrations 1")}

                            </ListItem>

                        </OrderedList>

                    </ListItem>
                    <ListItem className="sub-header-privacy" padding={2}>
                        <span>{t("Termination and Remedies")}</span>
                        <OrderedList className="body-privacy" listStyleType="lower-alpha">

                            {Array(6).fill(null).map((value, index) => (
                                <ListItem padding={2}>
                                    <span>{t("Termination and Remedies " + (index + 1))}</span>
                                </ListItem>
                            ))}
                        </OrderedList>

                    </ListItem>
                    <ListItem className="sub-header-privacy" padding={2}>
                        <span>{t("Miscellaneous")}</span>
                        <OrderedList className="body-privacy" listStyleType="lower-alpha">

                            {Array(6).fill(null).map((value, index) => (
                                <ListItem padding={2}>
                                    <span>{t("Miscellaneous " + (index + 1))}</span>
                                </ListItem>
                            ))}
                        </OrderedList>

                    </ListItem>
                    <ListItem className="sub-header-privacy" padding={2}>
                        <span>{t("Additional Items")}</span>
                        <OrderedList className="body-privacy" listStyleType="lower-alpha">

                            {Array(2).fill(null).map((value, index) => (
                                <ListItem padding={2}>
                                    <span>{t("Additional Items " + (index + 1))}</span>
                                </ListItem>
                            ))}

                            <ListItem padding={2}>
                                <span>{t("Additional Items 3")}</span>
                                <OrderedList listStyleType="lower-roman">

                                    {Array(2).fill(null).map((value, index) => (
                                        <ListItem padding={2}>
                                            <span>{t("Additional Items 3 " + (index + 1))}</span>
                                        </ListItem>
                                    ))}

                                </OrderedList>
                            </ListItem>
                            <ListItem padding={2}>
                                <span>{t("Additional Items 4")}</span>

                            </ListItem>
                            <ListItem padding={2}>
                                <span>{t("Additional Items 5")}</span>
                                <OrderedList listStyleType="lower-roman">

                                    {Array(2).fill(null).map((value, index) => (
                                        <ListItem padding={2}>
                                            <span>{t("Additional Items 5 " + (index + 1))}</span>
                                        </ListItem>
                                    ))}

                                </OrderedList>
                            </ListItem>
                            {Array(3).fill(null).map((value, index) => (
                                <ListItem padding={2}>
                                    <span>{t("Additional Items " + (index + 6))}</span>
                                </ListItem>
                            ))}
                        </OrderedList>


                    </ListItem>
                    <ListItem className="sub-header-privacy" padding={2}>
                        <span>{t("Governing Law and Forum")}</span>
                        <OrderedList className="body-privacy" listStyleType="lower-alpha">

                            <ListItem padding={2}>
                                <span>{t("Governing Law and Forum 1")}</span>
                            </ListItem>

                        </OrderedList>

                    </ListItem> <ListItem className="sub-header-privacy" padding={2}>
                    <span>{t("Indie")}</span>
                    <OrderedList className="body-privacy" listStyleType="lower-alpha">

                        <ListItem padding={2}>
                            <span>{t("Indie 1")}</span>
                        </ListItem>

                    </OrderedList>

                </ListItem>
                </OrderedList>
            </Box>
        </Flex>
        <BackgroundComponent/>
    </Box>

}
export default TermsOfUsePage